import { QueryKey, UseQueryOptions, useQuery } from 'react-query';
import { getNLPSearch } from 'services/app';

type NLPSearchParams = {
  query: string;
  request_origin?: string;
};

export default function useNLPSearch(
  params: NLPSearchParams,
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    ['nlp-search', params],
    () => {
      return getNLPSearch(params).then((response) => {
        if (!response.ok) {
          throw new Error(response?.originalError?.message || '');
        }
        return response.data;
      });
    },
    {
      ...options,
      cacheTime: 0,
      staleTime: 0,
    }
  );
}
